export default __webpack_public_path__ + "static/media/NoirPro-SemiBold.94659a79.woff2";